//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import { date } from "quasar";
import {
    mapActions,
    mapState
} from "vuex";
import numericsimple from "@/components/numericSimple";
import numericclean from "@/components/numericClean";
import postalcodes from "../../shared/postalcodes.json";
import logger from "@/utils/logger";

export default {
    props: {
        order: {},
        departmentIds: {
            type: Array,
            required: false,
            default: () => []
        },
    },
    components: {
        numericclean,
        numericsimple
    },

    data() {
        return {
            pagination: {
                rowsPerPage: 30,
                // current rows per page being displayed
            },
            paginationItems: {
                rowsPerPage: 30,
                sortBy: "id",
                descending: true, // current rows per page being displayed
            },
            paginationSmall: {
                rowsPerPage: 5, // current rows per page being displayed
            },
            allPaymentCompleted: true,
            isLoadingOrder: false,
            showPickingListDialog: false,
            pickingListWarehouses: [],
            localOrder: {},
            showPicking: false,
            showPickAllError: false,
            errorsPickAll: 0,
            errorMessagePickAll: "",
            errorMessagePacking: "",
            CompanySettings: [],
            consignorParcels: [],
            defaultConsignorParcel: {},
            qtyParcelId: 1,
            totalParcels: 1,
            totalWeight: 0,
            disablePacking: false,
            disablePickAll: false,
            enableConsignor: false,
            carrierProductId: 0,
            axiaCarrierProduct: 0,
            showProjectOrder: true,
            errorBeforeSendingToConsignor: 0,
            disableWarehouse: false,
            orderNumber: "",
            showOrderPacking: false,
            savePackingInProgress: false,
            requestPaymentInProgress: false,
            showRequestPaymentSpinner: false,
            confirmProjectOrder: false,
            customers: [],
            selectedLine: {},
            stock: [],
            packings: [],
            pickedProductsReadyToPackaging: [],
            transactions: [],
            warehouseId: -1,
            restQuantity: 0,
            Location: null,
            lineQuantity: 0,
            isStockControlled: false,
            picked: 0,
            volume: 0,
            colli: 1,
            qtyParcel: 0,
            weight: 0,
            packingSlips: false,
            consignor: false,
            sendEmail: false,
            disablePick: true,
            disableDelete: false,
            serialNumbers: [],
            freight: {},
            Warehouses: [],
            carriers: [],
            carrierId: -1,
            carrier: null,
            carrierProducts: [],
            FilterCarrierProducts: [],
            AxiaOptions: [],
            FilterWarehouses: [],
            Locations: [],
            FilterLocations: [],
            tab: "details",
            tabCustomer: "customerTab",
            rowCount: 10,
            dense: true,
            visibleColumns: [ 
                "productNumber",
                "itemText",
                "quantity",
                "picked",
                "numberOfItemsAvailableInStock",
                "departmentId",
                "joinedSerialNumbers",
                "purchaseOrderRef",
            ],
            columns: [{
                    name: "productNumber",
                    align: "left",
                    label: this.$t("order.productNumber"),
                    field: "productNumber",
                    style: "width: 200px",
                    sortable: true,
                    colspan: 2
                },

                {
                    name: "itemText",
                    align: "left",
                    label: this.$t("order.itemText"),
                    field: "itemText",
                    sortable: true,
                },
                {
                    name: "quantity",
                    align: "right",
                    label: this.$t("order.quantity"),
                    field: "numberOfItems",
                    style: "width: 100px",
                    sortable: true,
                },
                {
                    name: "picked",
                    align: "right",
                    label: this.$t("order.qtypicked"),
                    field: "picked",
                    style: "width: 100px",
                    sortable: true,
                },
                {
                    name: "numberOfItemsAvailableInStock",
                    align: "right",
                    label: this.$t("products.qty"),
                    field: "numberOfItemsAvailableInStock",
                    style: "width: 100px",
                    sortable: true,
                },
                {
                  name: "departmentId",
                  align: "left",
                  label: "Lager",
                  field: "departmentId",
                  format: (val) => this.getDepartmentName(val),
                  sortable: true,
                },
               
                {
                    name: "joinedSerialNumbers",
                    align: "left",
                    label: this.$t("pick.serialNumbers"),
                    field: (row) => row.joinedSerialNumbers,
                    style: "max-width: 200px;overflow: hidden;text-overflow: ellipsis;",
                    sortable: true,
                },
                {
                  name: "purchaseOrderRef",
                  align: "left",
                  label: "",
                  field: "purchaseOrder",
                  format: (val) => this.purchaseOrderRef(val),
                  sortable: true,
                  style: "width: 35px",
                },
            ],
            transactionColumns: [{
                    name: "location.warehouseName",
                    align: "left",
                    label: "Lager",
                    field: (row) => {
                        if (row.location) return row.location.warehouseName;
                        return "(ikke lagerført)";
                    },

                    sortable: true,
                },
                {
                    name: "locationName",
                    align: "left",
                    label: this.$t("order.locationName"),
                    field: "locationName",
                    sortable: true,
                },
                {
                    name: "serialNumbers",
                    align: "left",
                    label: this.$t("pick.serialNumbers"),
                    field: "serialNumbers",
                    style: "max-width: 300px;",
                    sortable: true,
                },
                {
                    name: "picked",
                    align: "left",
                    label: this.$t("order.picked"),
                    field: "picked",
                    sortable: true,
                },
            ],
            pickedProductsReadyToPackagingColumn: [{
                    name: "productName",
                    align: "left",
                    label: this.$t("order.productName"),
                    field: "productName",
                    sortable: true,
                },
                {
                    name: "locationName",
                    align: "left",
                    label: this.$t("order.locationName"),
                    field: "locationName",
                    sortable: true,
                },
                {
                    name: "picked",
                    align: "left",
                    label: this.$t("order.picked"),
                    field: "picked",
                    sortable: true,
                },
            ],
            packageColumns: [{
                    name: "id",
                    align: "left",
                    label: "Id",
                    field: "id",
                    sortable: true,
                },
                {
                    name: "parcels",
                    align: "left",
                    label: "Kolli",
                    field: "parcels",
                    sortable: true,
                },
                {
                    name: "volume",
                    align: "left",
                    label: "Volume (dm3)",
                    field: "volume",
                    sortable: true,
                },
                {
                    name: "weight",
                    align: "left",
                    label: "Vekt (kilo)",
                    field: "weight",
                    sortable: true,
                },
                {
                    name: "shipmentId",
                    align: "left",
                    label: "ShipmentID",
                    field: "shipmentId",
                    sortable: true,
                },
                {
                    name: "shipmentNumber",
                    align: "left",
                    label: "Shipmentnummer",
                    field: "shipmentNumber",
                    sortable: true,
                },
                {
                    name: "priceIncServices",
                    align: "left",
                    label: "Pris",
                    field: "priceIncServices",
                    sortable: true,
                },
            ],
            consignorParcelsColumns: [{
                    name: "colli",
                    align: "left",
                    label: "Kolli",
                    field: "colli",
                    sortable: true,
                },
                {
                    name: "volume",
                    align: "left",
                    label: "Volume (dm3)",
                    field: "volume",
                    sortable: true,
                },
                {
                    name: "weight",
                    align: "left",
                    label: "Vekt (kilo)",
                    field: "weight",
                    sortable: true,
                },
            ],
        };
    },

    computed: {
        ...mapState("main", ["warehouses", "companySettings", "locations", "departments", "user"]),
    },

    watch: {
        async order() {
            await this.loadOrder();
        },

        warehouseId(newValue, oldValue) {
            if (newValue !== oldValue && this.Location != null && this.Location.warehouseId !== newValue) {
                this.Location = null;
            }

            if (!this.stock || this.stock.length === 0)
                return;

            var warehouseLocations = this.stock.filter(item => item.warehouseId === newValue);
            this.Locations = warehouseLocations.filter(l => l.quantity !== 0);
            if (warehouseLocations.length === 1) {
                this.Location = warehouseLocations[0];
            }
        },

        carrierId(newValue, oldValue) {
            if (newValue != oldValue && newValue.id > 0) {
                var carrier = this.carriers.find((x) => x.id == newValue.id);
                this.carrierProducts = carrier.products;
            }
        },

        Location(newValue, oldValue) {
            if (newValue != oldValue) {
                var loc = this.Locations.filter((l) => {
                    return newValue && (l.locationId == newValue.locationId);
                });
                if (loc && loc.length > 0 && this.warehouseId != loc[0].warehouseId) {
                    this.warehouseId = loc[0].warehouseId;
                }
                this.checkDisablePick();
            }
        },

        picked(newValue, oldValue) {
            if (newValue != oldValue) {
                this.checkDisablePick();
            }
        },

        serialNumbers(newValue, oldValue) {
            if (newValue != oldValue) {
                for (var i = 0; i < newValue.length; i++) {
                    var test = newValue[i].split(",");
                    if (test.length > 1) {
                        newValue[i] = test[0];
                        for (var j = 1; j < test.length; j++) {
                            if (test[j]) {
                                newValue.push(test[j]);
                            }
                        }
                    }
                }

                this.checkDisablePick();
            }
        },
    },

    methods: {
        async journalEntryPost(orderItemid){
            logger.log("journalEntryPost " + orderItemid);
            const loading = this.$q.notify({type: "ongoing",message: "Oppretter billag",});
            try {                   
                await this.postAddJournalentry(orderItemid);                
                await this.itemsChanged();
                loading();
                this.$q.notify({type: 'positive',message: "Vellyket"});
            } catch (err) {
                loading();
                logger.log(err.message);
                this.$q.notify({type: "negative",message: this.$t("common.errorSave") + " " + err,});
            } 
        },

        onVisibleColumnsChange() {
            if (this.isRecevingMode)
                this.$cookies.set(
                    "customerOrderItemRecieveColumns",
                    this.visibleColumns.join(","),
                    "1Y"
                );
            else
                this.$cookies.set(
                    "customerOrderItemColumns",
                    this.visibleColumns.join(","),
                    "1Y"
                );
        },
        initVisibleColumns() {
            var cookieColums = this.$cookies.get("customerOrderItemColumns");
            if (this.isRecevingMode)
                cookieColums = this.$cookies.get("customerOrderItemRecieveColumns");

            if (cookieColums) {
                var columns = [];
                cookieColums.split(",").forEach(function (col) {
                    columns.push(col);
                });
                this.visibleColumns = columns;
            }
        },

      purchaseOrderRef(purchaseOrder){
        if(purchaseOrder)
          {
            logger.log(purchaseOrder.id);
            return '<div class="tooltip"><a href="/#/PurchaseOrders/'+purchaseOrder.id+'"><img src="/icons/purchaseOrder.svg" style="height: 31px; font-size: 1.715em" /></a><span class="tooltiptext">'+purchaseOrder.orderNumber+'</span></div>';
          }
        return '';
      },

      getDepartmentName(departmentId) {
        const department = this.warehouses.find((d) => d.id === departmentId);
        return department ? department.warehouseName : "";
      },

        checkDisablePick() {
            if (
                this.isStockControlled &&
                (this.Location == null ||
                    this.numberOfItemsAvailableInStock == 0 ||
                    this.picked > this.Location.quantity)
            ) {
                this.disablePick = true;
            } else if (
                this.serialNumberEnabled &&
                this.serialNumbers.length != this.picked
            ) {
                this.disablePick = true;
            } else if (this.picked > this.restQuantity) {
                this.disablePick = true;
            } else if (this.picked < 0) {
                this.disablePick = true;
            } else if (this.restQuantity == 0) {
                this.disablePick = true;
            } else if (this.picked == 0) {
                this.disablePick = true;
            } else if (!this.picked) {
                this.disablePick = true; // Legge til sjekk på max antall serienummer??
            } else {
                this.disablePick = false;
            }
        },

        isOrderTransactionNull(props) {
            if (props.row.transactions[0] != undefined) {
                if (props.row.transactions[0].customerOrderPackage == null) {
                    return true;
                } else {
                    return false;
                }
            }

            return true;
        },

        async savePicking() {
            this.disablePick = true;
            var postStock = {};
            postStock.customerOrderItemId = this.selectedLine.id;
            postStock.locationId = this.Location ? this.Location.locationId : -1;

            postStock.picked = parseFloat(this.picked.toString().replace(",", "."));
            postStock.serialNumbers = this.serialNumbers.toString();

            try {
                var createdDto = await this.postCustomerOrderItemTransaction(postStock);
                if (createdDto) {
                    await this.itemsChanged();

                    if (createdDto.location) {
                        this.warehouseId = createdDto.location.warehouseId;
                        this.disableWarehouse = true;
                    }

                    this.showPicking = false;

                    this.$q.notify({
                        type: "positive",
                        message: this.$t("common.saveOk"),
                    });
                } else {
                    this.$q.notify({
                        type: "negative",
                        message: this.$t("common.errorSave"),
                    });
                }
            } catch (err) {
                logger.log(err);
                this.$q.notify({
                    type: "negative",
                    message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(err)}`,
                });
            }
            if (this.order.deliveryTerms && this.order.deliveryTerms.includes("Prosjektordre")) {
                try {
                    this.disableDelete = true;

                    await this.projectOrderSubmit();
                    this.showPicking = false;
                } catch {
                    logger.log("Error");
                }
            }

            this.disablePick = false;
        },

        async tryToPickAllItems() {
            try {
                this.disablePickAll = true;

                var warehouseId = null;
                this.showPickAllError = false;
                this.errorsPickAll = 0;
                this.errorMessagePickAll = "";
                var itemsPickedNotPacked = this.localOrder.orderItems.filter(
                    (i) =>
                    (i.stockControlled && i.picked - i.packed) > 0 &&
                    i.transactions.filter((t) => t.customerOrderPackage == null)
                    .length > 0
                );
                if (itemsPickedNotPacked.length > 0) {
                    var transactions = itemsPickedNotPacked[0].transactions.filter(
                        (t) => t.customerOrderPackage == null
                    );
                    if (transactions.length > 0) {
                        warehouseId = transactions[0].location.warehouseId;
                    }
                }

                for (var i = 0; i < this.localOrder.orderItems.length; i++) {
                    var item = this.localOrder.orderItems[i];

                    if (item.isHeadLine) {
                        continue;
                    }

                    var itemError = "";
                    if (item.numberOfItems - item.picked > 0) {
                        var stock = null;
                        if (item.serialNumberEnabled) {
                            itemError =
                                "* Kan ikke autoplukke ordrelinjen " +
                                item.itemText +
                                " pga. at serienummer må angis. ";
                            this.errorsPickAll++;
                        } else if (item.stockControlled) {
                            if (item.stock == null || item.stock.length == 0) {
                                itemError =
                                    "* Kan ikke autoplukke ordrelinjen " +
                                    item.itemText +
                                    " pga. manglende lokasjon. ";
                                this.errorsPickAll++;
                            } else {
                                var stocks = warehouseId ?
                                    item.stock.filter((x) => x.warehouseId == warehouseId) :
                                    item.stock;
                                if (stocks.length > 1) {
                                    itemError =
                                        "* Kan ikke autoplukke ordrelinjen " +
                                        item.itemText +
                                        " pga. flere lokasjoner. ";
                                    this.errorsPickAll++;
                                } else if (stocks.length == 0) {
                                    itemError =
                                        "* Kan ikke autoplukke ordrelinjen " +
                                        item.itemText +
                                        " pga. manglende lokasjon på lager til aktivt plukk. ";
                                    this.errorsPickAll++;
                                } else if (
                                    item.numberOfItems - item.picked >
                                    stocks[0].quantity
                                ) {
                                    itemError =
                                        "* Kan ikke autoplukke ordrelinjen " +
                                        item.itemText +
                                        " pga. for få på lager. ";
                                    this.errorsPickAll++;
                                } else {
                                    stock = stocks[0];
                                }
                            }
                        }

                        if (itemError == "") {
                            if (warehouseId == null && item.stockControlled) {
                                warehouseId = stock.warehouseId;
                            }
                            var postStock = {};
                            postStock.customerOrderItemId = item.id;
                            postStock.locationId =
                                stock && item.stockControlled ? stock.locationId : -1;
                            postStock.picked = item.numberOfItems - item.picked;

                            var createdDto = await this.postCustomerOrderItemTransaction(
                                postStock
                            );
                            await this.itemsChanged();
                            if (!createdDto) {
                                this.errorMessagePickAll +=
                                    (this.errorMessagePickAll ? "\n" : "") +
                                    "* Feilet i plukking av " +
                                    item.name +
                                    ". ";
                                this.errorsPickAll++;
                            }
                        } else {
                            this.errorMessagePickAll +=
                                (this.errorMessagePickAll ? "\n" : "") + itemError;
                        }
                    }
                }

                if (this.errorMessagePickAll == "") {
                    this.$q.notify({
                        type: "positive",
                        message: this.$t("common.saveOk"),
                    });
                } else {
                    this.showPickAllError = true;
                }
            } catch (err) {
                logger.log(err);
                this.$q.notify({
                    type: "negative",
                    message: this.$t("common.errorSave"),
                });
            }

            this.disablePickAll = false;
        },

        showPickAllItems() {
            if (this.localOrder && this.localOrder.orderItems) {
                var itemsToPick = this.localOrder.orderItems.filter(
                    (i) => i.numberOfItems - i.picked > 0
                );
                return itemsToPick.length > 0;
            }
            return false;
        },

        async deleteval(row) {
            var res = await this.deleteCustomerOrderItemTransaction(row.id);
            this.disableWarehouse = false;

            if (res == "true") {
                var index = this.transactions.indexOf(row);
                this.transactions.splice(index, 1);
                await this.itemsChanged();
            } else {
                this.$q.notify({
                    type: "negative",
                    message: this.$t("common.errorSave"),
                });
            }
        },

        // The orders list endpoint only returns header fields, so the line items / stock /
        // transactions are fetched here on demand when a row is expanded.
        async loadOrder() {
            if (!this.order || !this.order.id) {
                this.localOrder = this.order || {};
                return;
            }

            this.isLoadingOrder = true;
            try {
                const data = await this.getSalesOrder(this.order.id);
                this.applyOrderGrouping(data);
            } finally {
                this.isLoadingOrder = false;
            }
        },

        // Orders the lines so each head line is immediately followed by its sub lines.
        applyOrderGrouping(orderData) {
            this.localOrder = orderData;

            const items = this.localOrder.orderItems || [];
            const headItems = items.filter(item => item.sortIndex !== null);
            const underItems = items.filter(item => item.sortIndex === null);

            headItems.sort((a, b) => a.sortIndex - b.sortIndex);

            const finalList = [];
            for (const item of headItems) {
                finalList.push(item);
                const children = underItems.filter(ui => ui.headLineId === item.id);
                finalList.push(...children);
            }

            this.localOrder.orderItems = finalList;
        },

        async itemsChanged() {
            const data = await this.getSalesOrder(this.localOrder.id);
            this.localOrder = data;
            await this.$emit("itemsChanged", data);
            await this.refresh();
        },

        async pickingListPdf() {

            var orderItemsWarehouses = [];

            for (let i = 0; i < this.localOrder.orderItems.length; i++) {
                var item = this.localOrder.orderItems[i];

                if (item.picked == item.quantity)
                    continue;

                if (orderItemsWarehouses.includes(item.departmentId))
                    continue;

                orderItemsWarehouses.push(item.departmentId);
            }

            if (orderItemsWarehouses.length == 1) {
                this.downloadPickingListPdf();
            } else {
                logger.log(orderItemsWarehouses);

                this.pickingListWarehouses = [];

                if (orderItemsWarehouses.includes(null)) {
                    this.pickingListWarehouses.push({
                        id: null,
                        warehouseName: "Lager ikke valgt"
                    });
                }

                this.warehouses.forEach((item) => {
                    if (orderItemsWarehouses.includes(item.id)) {
                        this.pickingListWarehouses.push(item);
                    }
                });

                logger.log(this.pickingListWarehouses);
                this.showPickingListDialog = true;
            }
        },

        async downloadPickingListPdfForWarehouse(warehouseId) {
            const notif = this.$q.notify({
                message: this.$t("common.downloading"),
                timeout: 0,
                spinner: true,
            });
            var res = await this.getPickingListReport({
                customerOrderId: parseInt(this.localOrder.id),
                warehouseId: warehouseId
            });
            notif();

            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement("a");
            link.href = url;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                link.setAttribute("target", "_blank");
            } else {
                link.setAttribute("download", "PickingList.pdf");
            }
            // // link.setAttribute("download", "PackingSlip.pdf");
            // link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            this.packingSlips = false;
        },

        async downloadPickingListPdf() {
            const notif = this.$q.notify({
                message: this.$t("common.downloading"),
                timeout: 0,
                spinner: true,
            });
            var res = await this.getPickingListReport({
                customerOrderId: parseInt(this.localOrder.id),
                warehouseId: null
            });
            notif();

            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement("a");
            link.href = url;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                link.setAttribute("target", "_blank");
            } else {
                link.setAttribute("download", "PickingList.pdf");
            }
            // // link.setAttribute("download", "PackingSlip.pdf");
            // link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            this.packingSlips = false;
        },

        async packOrder() {
            this.errorBeforeSendingToConsignor = 0;
            this.errorMessagePacking = "";
            this.defaultConsignorParcel = {};
            this.carrierProductId = 0;
            this.axiaCarrierProduct = 0;
            this.carrierId = 0;
            this.consignorParcels = [];
            var warehouseGLN = "";

            try {
                this.pickedProductsReadyToPackaging = await this.getpickedProductsReadyToPackaging(this.localOrder.id);
            } catch (err) {
                logger.log(err);
                this.$q.notify({
                    type: "negative",
                    message: `${err}`,
                });

                return;
            }

            this.pickedProductsReadyToPackaging.forEach((item) => {
                if (item.location != null) {
                    var wh = this.Warehouses.find(
                        (x) => x.warehouseId == item.warehouseId
                    );
                    warehouseGLN = wh.gln;
                }
            });

            if (!warehouseGLN) {
                this.warehouses.forEach((item) => {
                    if (item.gln) {
                        warehouseGLN = item.gln;
                    }
                });
            }

            try {
                if (warehouseGLN) {
                    this.AxiaOptions = await this.getAxiaOptions(warehouseGLN);
                    this.carriers = this.AxiaOptions.carriers;
                }
            } catch (error) {
                console.warn("Axia Options returned empty")
            }

            this.pickedProductsReadyToPackaging = this.pickedProductsReadyToPackaging.filter((p) => !p.customerOrderPackage);

            var weight = 0;
            // var allFreight = true;

            this.pickedProductsReadyToPackaging.forEach((item) => {
                if (item.productWeight) {
                    weight += item.productWeight * item.picked;
                }
            });

            if (this.enableConsignor) {
                this.defaultConsignorParcel = {
                    colli: this.colli,
                    volume: 1,
                    weight: weight,
                };
                if (weight < 1) {
                    this.defaultConsignorParcel.weight = 1;
                }
                this.consignorParcels.push(this.defaultConsignorParcel);
                if (!warehouseGLN && this.freight.clientType == 2) {
                    this.errorMessagePacking =
                        "* Mangler GLN på lager som matcher Axia " + "\n";
                    this.errorBeforeSendingToConsignor++;
                }

                if (!this.order.shippingAddressLine1) {
                    this.errorMessagePacking = "* Mangler adresse " + "\n";
                    this.errorBeforeSendingToConsignor++;
                }
                if (!this.order.shippingCity) {
                    this.errorMessagePacking += "* Mangler sted" + "\n";
                    this.errorBeforeSendingToConsignor++;
                }
                // if (!this.order.shippingCountryCode) {
                //   this.errorMessagePacking += "* Mangler land" + "\n";
                //   this.errorBeforeSendingToConsignor++;
                // }
                if (!this.order.shippingPostalCode) {
                    this.errorMessagePacking += "* Mangler postkode" + "\n";
                    this.errorBeforeSendingToConsignor++;
                } else {
                    if (
                        postalcodes.Postalcode.find(
                            (x) => x == this.order.shippingPostalCode
                        ) === undefined
                    ) {
                        this.errorMessagePacking +=
                            "* Ugyldig postkode (" + this.order.shippingPostalCode + ")\n";
                        this.errorBeforeSendingToConsignor++;
                    }
                }
            }

            if (this.pickedProductsReadyToPackaging.length < 1) {
                this.errorMessagePacking += "* Mangler produkter";
                this.errorBeforeSendingToConsignor++;
            }

            this.allPaymentCompleted = true;
            if (this.localOrder.ebridgeOrderNumber) {
                this.pickedProductsReadyToPackaging.forEach((item) => {
                    var orderItem = this.localOrder.orderItems.find(
                        (x) => x.id == item.customerOrderItemId
                    );

                    if (!orderItem.paymentCompleted) {
                        this.allPaymentCompleted = false;
                    }
                });
            }

            this.weight = weight;
            this.showOrderPacking = true;
        },
        addRowConsignor() {
            var weight = 0;
            this.pickedProductsReadyToPackaging.forEach((item) => {
                if (item.productWeight) {
                    weight += item.productWeight * item.picked;
                }
            });
            this.qtyParcelId;
            const row = {
                colli: this.colli,
                volume: 1,
                weight: weight,
            };
            this.consignorParcels.push(row);

            if (this.consignorParcels.length > 0) {
                this.disablePacking = false;
            }
        },
        deleteLine(index) {
            //this.totalParcels -= index.colli;
            this.consignorParcels.splice(index, 1);
            // this.totalParcels = this.colli;

            if (this.consignorParcels.length === 0) {
                this.disablePacking = true;
            }
        },
        async getConsignorPrints(row) {
            const notif = this.$q.notify({
                message: this.$t("common.downloading"),
                timeout: 0,
                spinner: true,
            });
            if (this.freight.clientType == 1) {
                var res = await this.getConsignorLabels(row.ShpCSID);
                res.labels.forEach((element) => {

                    const linkSource = `data:application/pdf;base64,${element.content}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "printConsignor.pdf";

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                });
            } else if (this.freight.clientType == 2) {
                window.open(row.labelURL, "_blank").focus();
            }
            notif();
        },
        async getConsignorURL(row) {
            const notif = this.$q.notify({
                message: this.$t("common.downloading"),
                timeout: 0,
                spinner: true,
            });
            if (this.freight.clientType == 1) {
                var res = await this.getConsignorTracking(row.ShpCSID);

                window.open(res.trackingURL, "_blank").focus();
            } else if (this.freight.clientType == 2) {
                window.open(row.trackAndTraceURL, "_blank");
            }

            notif();
        },
        async packingPrintConsignor(createdDto) {
            if (this.freight.clientType == 1) {
                createdDto.labels.forEach((element) => {

                    const linkSource = `data:application/pdf;base64,${element}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "printConsignor.pdf";

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                });
            } else if (this.freight.clientType == 2) {
                if (createdDto.labelURL == "") {
                    logger.log("mangler url");
                } else {
                    window.open(createdDto.labelURL, "_blank");
                }

            }
        },

        async packingSlipPdf(packageId) {
            const notif = this.$q.notify({
                message: this.$t("common.downloading"),
                timeout: 0,
                spinner: true,
            });
            var payload = {
                packageId: packageId,
                sendEmail: this.sendEmail,
            };
            var res = await this.getPackingSlipReport(payload);
            notif();

            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement("a");
            link.href = url;

            if (navigator.userAgent.indexOf("Firefox") != -1) {
                link.setAttribute("target", "_blank");
            } else {
                link.setAttribute("download", "Packingslip.pdf");
            }

            // // link.setAttribute("download", "PackingSlip.pdf");
            // link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            this.packingSlips = false;
        },

        async openPackingSlips() {
            this.packingSlips = true;
            this.packings = await this.getCustomerOrderPackage(this.localOrder.id);
        },

        async unlock() {
            this.$q.notify({
                spinner: true,
                message: 'Låser opp ordre',
                timeout: 2000
            })

            await this.unlockOrder(this.localOrder.id);
            this.localOrder.lockedByUserName = null;
            this.localOrder.lockedBy = null;
            this.order.lockedByUserName = null;
            this.order.lockedBy = null;

        },

        async requestPayent() {
            this.requestPaymentInProgress = true;

            try {
                await this.requestPayment(this.order.id);
            } catch (err) {
                logger.log(err.message);
                this.$q.notify({
                    type: "negative",
                    message: this.$t("common.errorSave") + " " + err,
                });
                return;
            }

            this.showRequestPaymentSpinner = true;
            try {
                await this.waitEbridgePaymentCompleted(this.order.id);

                //Ingen error = allPayed
                this.allPaymentCompleted = true;
                //update order item

                await this.itemsChanged();
            } catch (err) {
                logger.log(err.message);
                this.$q.notify({
                    type: "negative",
                    message: this.$t("common.errorSave") + " " + err,
                });
            }
            this.requestPaymentInProgress = false;

            this.showRequestPaymentSpinner = false;
        },
        
        async projectOrderSubmit() {
            this.$q.notify({
                type: "positive",
                message: "Starter pakking av prosjektordre",
            });
            this.savePacking(true);
        },

        async showProjectOrderSubmit() {
            this.confirmProjectOrder = true;
        },

        async savePacking(projectOrder) {

            this.savePackingInProgress = true;
            try {
                if (this.localOrder.ebridgeOrderNumber) {
                    this.showEbridgeNotification = true;

                    // start payment
                    // Vent på at pakke er oppdatert med betaling

                    this.showEbridgeNotification = true;
                }
                if (this.enableConsignor) {
                    this.errorBeforeSendingToConsignor = 0;
                    this.errorMessagePacking = "";
                    var validate = true;
                    this.consignorParcels.forEach((item) => {
                        if (item.weight == 0) {

                            this.errorMessagePacking += "* Vekt kan ikke være 0 " + "\n";
                            this.errorBeforeSendingToConsignor++;
                            validate = false;
                        }
                        if (item.colli == 0) {

                            this.errorMessagePacking += "* Colli kan ikke være 0 " + "\n";
                            this.errorBeforeSendingToConsignor++;
                            validate = false;
                        }
                        if (item.volume == 0) {

                            this.errorMessagePacking += "* Volume kan ikke være 0 " + "\n";
                            this.errorBeforeSendingToConsignor++;
                            validate = false;
                        }
                    });
                    if (!validate) {
                        this.savePackingInProgress = false;
                        return;
                    }
                }
                var postPacking = {};
                postPacking.customerOrderId = parseInt(this.localOrder.id);
                postPacking.volume = this.volume;
                postPacking.weight = this.weight;
                postPacking.carrierProductId = this.carrierProductId;
                postPacking.axiaCarrierProductId = this.axiaCarrierProduct.code;
                postPacking.carrierId = this.carrierId.id;
                postPacking.consignorId = this.AxiaOptions.id;
                postPacking.sendToConsignor = this.consignor;
                postPacking.projectOrder = projectOrder;
                postPacking.parcels = this.consignorParcels;

                var createdDto = await this.postCustomerOrderPackage(postPacking);

                if (createdDto && createdDto.id > 0) {

                    if (!projectOrder) {
                        await this.packingSlipPdf(createdDto.id);
                    }
                    if (this.consignor) {
                        await this.packingPrintConsignor(createdDto);
                    }
                    this.itemsChanged();

                    await this.refresh();
                    this.showOrderPacking = false;
                    this.carrierProductId = 0;
                    this.axiaCarrierProductId = 0;
                    this.consignor = false;
                    this.packingslip = true;
                    this.sendEmail = false;
                    this.$q.notify({
                        type: "positive",
                        message: this.$t("common.saveOk"),
                    });
                } else {
                    this.$q.notify({
                        type: "negative",
                        message: this.$t("common.errorSave"),
                    });
                }

                this.showOrderPacking = false;
                this.savePackingInProgress = false;
            } catch (err) {
                this.disableDelete = false;
                logger.log(err.message);
                this.$q.notify({
                    type: "negative",
                    message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(err)}`,
                });
            }
            this.savePackingInProgress = false;
        },

        async refresh() {

            if (this.localOrder) {
                this.updateForm();
            }
            if (this.localOrder && this.localOrder.orderItems && this.localOrder.orderItems.filter((x) => x.picked == 0).length > 0) {

                this.showProjectOrder = true;
            }
        },

        async onRowClick(row) {
            this.resetForm();
            this.disableWarehouse = false;
            this.selectedLine = row;
            this.numberOfItems = row.numberOfItems;
            this.restQuantity = this.numberOfItems - row.picked;
            this.lineQuantity = row.quantity;
            this.numberOfItemsAvailableInStock = row.numberOfItemsAvailableInStock;
            this.isStockControlled = row.stockControlled;
            this.serialNumberEnabled = row.serialNumberEnabled;
            this.serialNumbers = row.serialNumbers ?
                row.serialNumbers.split(",") :
                [];
            if (this.restQuantity) {
                this.picked = this.restQuantity.toString().replace(".", ",");
            }

            this.stock = row.stock?.filter(item => item.quantity !== 0) || [];
            if (this.stock && this.stock.length === 1 && this.isStockControlled) {
                // if only at one location, autofill
                this.Location = this.stock[0];
                this.warehouseId = this.stock[0].warehouseId;
            }

            this.transactions = row.transactions || [];
            this.disablePick = this.isStockControlled;
            this.Warehouses = [...this.FilterWarehouses];

            if(row.departmentId){
                this.warehouseId = row.departmentId;
                this.disableWarehouse = true;

                const departmentWarehouse = this.FilterWarehouses.find(w => w.id === row.departmentId);
                if (departmentWarehouse && !this.Warehouses.find(w => w.id === row.departmentId)) {
                    this.Warehouses.push(departmentWarehouse);
                }
            }

            if (row.numberOfItems - row.picked > 0 || this.transactions.length !== 0) {
                this.showPicking = true;
            } else {
                this.savePicking();
            }
        },

        getWarehouseFilter(val, update) {
            if (!this.FilterWarehouses) {
                update();
                return;
            }
            
            update(() => {
                const needle = val.toLowerCase();
                if (this.selectedLine && this.selectedLine.departmentId && this.stock && this.stock.length > 0) {
                    const warehousesWithStock = new Set(
                        this.stock.map(s => s.warehouseId)
                    );

                    this.Warehouses = this.FilterWarehouses.filter(
                        (w) =>
                        !w.isDeleted &&
                        warehousesWithStock.has(w.id) &&
                        w.warehouseName.toLowerCase().indexOf(needle) > -1
                    );
                } else {
                    this.Warehouses = this.FilterWarehouses.filter(
                        (w) =>
                        !w.isDeleted &&
                        w.warehouseName.toLowerCase().indexOf(needle) > -1
                    );
                }
            });
        },

        getLocationsFilter(val, update) {
            if (!this.stock) {
                update();
                return;
            }
            
            update(() => {
                const needle = val.toLowerCase();
                this.Locations = this.stock.filter(
                    (l) => 
                    (this.warehouseId < 1 || l.warehouseId === this.warehouseId) && 
                    l.quantity !== 0 &&
                    l.locationName.toLowerCase().indexOf(needle) > -1
                );
            });
        },

        resetForm() {
            this.picked = 0;
            this.warehouseId = -1;
            this.carrierId = 0;
            this.carrierProductId = 0;
            this.axiaCarrierProduct = 0;
            this.Location = null;
            this.serialNumbers = [];
            this.Warehouses = [...this.FilterWarehouses];
        },

        updateForm() {
            this.picked = "";
            this.warehouseId = -1;
            this.Location = null;
            this.serialNumbers = [];
            this.Warehouses = [...this.FilterWarehouses];

            var selectedLine = this.localOrder.orderItems.find(
                (x) => x.id == this.selectedLine.id
            );
            if (selectedLine) {
                this.transactions = selectedLine.transactions;
                var picked = 0;
                this.transactions.forEach((item) => {
                    picked += item.picked;
                });

                this.restQuantity = this.numberOfItems - picked;
            }
        },

        ...mapActions("main", [
            "getSalesOrder",
            "getCustomer",
            "postCustomerOrderItemTransaction",
            "deleteCustomerOrderItemTransaction",
            "getCustomerOrderItemTransactions",
            "getpickedProductsReadyToPackaging",
            "postCustomerOrderPackage",
            "getCustomerOrderPackage",
            "unlockOrder",
            "getPackingSlipReport",
            "getPickingListReport",
            "getConsignorLabels",
            "getConsignorTracking",
            "getConsignor",
            "getAxiaOptions",
            "requestPayment",
            "waitEbridgePaymentCompleted",
            "postAddJournalentry"
        ]),
    },

    async created() {
        this.initVisibleColumns();
        // GET request using fetch with error handling
        this.CompanySettings = this.companySettings;
        this.freight = await this.getConsignor();
        this.enableConsignor = this.freight.enabled;
        this.Warehouses = this.warehouses;
        this.FilterWarehouses = this.warehouses;
        this.Locations = this.locations;
        this.FilterLocations = this.locations;


        // if (this.order) {
        //    this.orderLines = this.order.orderItems;
        // }
    },

    async mounted() {
        await this.loadOrder();
    },
};
